import React, { useState } from 'react'
 
 
import RentedInvoiceList from './RentedInvoiceList';
import RentedInvoiceForm from './RentedInvoiceForm';

const RentedInvoice= () => {
    const [fromIsShown, setFromIsShown] = useState(false);
    const [upData, setUpData] = useState(false);
    const [serviceId, setServiceId] = useState("none");

  return (
    <>
      {fromIsShown ? (
          <RentedInvoiceForm addForm={setFromIsShown} update={upData}   sId={serviceId}/>
        ) : (
          <RentedInvoiceList addForm={setFromIsShown} update={setUpData}   sId={setServiceId}/>
        )}  
    </>
  )
}

export default RentedInvoice